import React from 'react';
import parse from 'html-react-parser';

export default function AboutSection({ imgUrl, title, subTitle }) {
  // We use hardcoded pillars to match the brand design HTML if not provided via props
  const defaultPillars = [
    "Evidence-based therapeutic approaches",
    "Culturally responsive and inclusive care",
    "Integrated individual and organizational support",
    "Community education and stigma reduction"
  ];

  return (
    <section id="about" className="bg-white py-28 relative">
      <div className="max-w-[1200px] mx-auto px-6 md:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-center">
          <div className="relative">
            <div className="absolute -inset-3 border border-crimson rounded opacity-30 pointer-events-none"></div>
            <div className="bg-cream border border-cream-dark p-0 overflow-hidden rounded relative z-10 hidden md:block" style={{ height: '420px' }}>
              <img src={imgUrl || "/images/home_1/Noohra-Services7.webp"} alt="About Noohra" className="w-full h-full object-cover object-center block" />
            </div>
            {/* Mobile fallback img */}
            <div className="bg-cream border border-cream-dark p-0 overflow-hidden rounded relative z-10 md:hidden h-[300px]">
              <img src={imgUrl || "/images/home_1/Noohra-Services7.webp"} alt="About Noohra" className="w-full h-full object-cover object-center block" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-[120px] h-[120px] bg-crimson rounded-full opacity-[0.08] z-0"></div>
          </div>
          
          <div>
            <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
              <span className="w-[24px] h-px bg-gold block"></span>
              {title || "About Us"}
            </div>
            
            <h2 className="font-serif text-4xl md:text-[3rem] font-light leading-[1.2] text-charcoal mb-6">
              {subTitle ? parse(subTitle) : parse("A holistic approach to <em className='italic text-crimson'>mental wellness</em>")}
            </h2>
            
            <p className="text-base leading-[1.85] text-mid font-light mb-[1.2rem]">
              Noohra Integrated & Allied Services Ltd. is a leading mental health organization based in Nigeria, dedicated to providing evidence-based, culturally sensitive care to individuals, families, and organizations.
            </p>
            <p className="text-base leading-[1.85] text-mid font-light mb-[1.2rem]">
              We believe that mental health is foundational to every aspect of human flourishing — from personal relationships to professional performance. Our integrated approach combines clinical expertise with educational outreach to create lasting change.
            </p>
            
            <div className="flex items-center gap-6 my-8">
              <div className="flex-1 h-px bg-cream-dark"></div>
              <div className="text-gold text-sm">◆</div>
              <div className="flex-1 h-px bg-cream-dark"></div>
            </div>
            
            <div className="flex flex-col gap-3 mt-8">
              {defaultPillars.map((text, i) => (
                <div key={i} className="flex items-center gap-4 text-sm font-medium text-charcoal">
                  <div className="w-2 h-2 rounded-full bg-crimson shrink-0"></div>
                  {text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
